<template>
  <div>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
       <el-avatar> {{displayName}} </el-avatar>
      </CHeaderNavLink>
    </template>

    <!--<CDropdownItem>-->
      <!--<CIcon name="cil-bell"/> Updates-->
      <!--<CBadge color="info" class="mfs-auto">{{ itemsCount }}</CBadge>-->
    <!--</CDropdownItem>-->
    <!--<CDropdownItem>-->
      <!--<CIcon name="cil-envelope-open" /> Messages-->
      <!--<CBadge color="success" class="mfs-auto">{{ itemsCount }}</CBadge>-->
    <!--</CDropdownItem>-->
    <!--<CDropdownItem>-->
      <!--<CIcon name="cil-task" /> Tasks-->
      <!--<CBadge color="danger" class="mfs-auto">{{ itemsCount }}</CBadge>-->
    <!--</CDropdownItem>-->
    <!--<CDropdownItem>-->
      <!--<CIcon name="cil-comment-square" /> Comments-->
      <!--<CBadge color="warning" class="mfs-auto">{{ itemsCount }}</CBadge>-->
    <!--</CDropdownItem>-->

    <!--<CDropdownHeader-->
      <!--tag="div"-->
      <!--class="text-center"-->
      <!--color="light" >-->
      <!--<strong>Settings</strong>-->
    <!--</CDropdownHeader>-->
    <!--<CDropdownItem>-->
      <!--<CIcon name="cil-user" /> Profile-->
    <!--</CDropdownItem>-->
    <!--<CDropdownItem>-->
      <!--<CIcon name="cil-settings" /> Settings-->
    <!--</CDropdownItem>-->
    <!--<CDropdownItem>-->
      <!--<CIcon name="cil-dollar" /> Payments-->
      <!--<CBadge color="secondary" class="mfs-auto">{{ itemsCount }}</CBadge>-->
    <!--</CDropdownItem>-->
    <!--<CDropdownItem>-->
      <!--<CIcon name="cil-file" /> Projects-->
      <!--<CBadge color="primary" class="mfs-auto">{{ itemsCount }}</CBadge>-->
    <!--</CDropdownItem>-->


    <CDropdownItem>
    <CIcon name="cil-user" /> {{`[${orgName}/${displayName}]`}}
    </CDropdownItem>


    <CDropdownDivider/>

    <!--<CDropdownItem>-->
      <!--<CIcon name="cil-shield-alt" /> Lock Account-->
    <!--</CDropdownItem>-->

    <CDropdownItem @click="changePassword">
      <CIcon name="cil-lock-locked"  /> 修改密碼
    </CDropdownItem>

    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked" /> 登出
    </CDropdownItem>
  </CDropdown>

  <EditPasswdDlg
    v-model="editPasswdDlgVisible"
    :key="dlgKey"
  ></EditPasswdDlg>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EditPasswdDlg from "../components/EditPasswdDlg"
export default {
  name: 'TheHeaderDropdownAccnt',
  components: {
    EditPasswdDlg,
  },
  data () {
    return { 
      editPasswdDlgVisible: false,
      dlgKey: false,
      itemsCount: 42
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout', null,).then(() => {
        this.$router.replace('/pages/login');
      });
    },
    changePassword () {
      this.editPasswdDlgVisible = true;
      this.dlgKey = this.dlgKey ? 0 : 1;
    },
  },
  computed: {
    ...mapGetters({
        displayName: 'auth/displayName',
        orgName: 'auth/orgName',
    }),
  },
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
